module.exports = __webpack_public_path__ + "img/share-India PNG.482a8924.png";